module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section02_05_american-village-ceb1c6767c22e6391fe7ccd62de45a1e.jpg";